import { Userbot } from "../interfaces"

/** Подсказки по {{...}}-плейсхолдерам для конструктора. */
export const TEMPLATE_HINTS: string[] = [
  "{{<stepId>.result.*}}",
  "{{<stepId>.params.*}}",
  "{{ctx.clientId}}",
  "{{ctx.accountId}}",
  "{{ctx.chainId}}",
  "{{ctx.now}}",
  "{{ctx.<key>}}",
  "{{item}}",
  "{{index}}",
  "{{input.*}}",
]

/** Дополнительные плейсхолдеры для триггерных цепочек. */
export const TRIGGER_TEMPLATE_HINTS: string[] = [
  "{{ctx.update.*}}",
  "{{ctx.updateType}}",
  "{{ctx.triggerId}}",
  "{{update.chatId}}",
  "{{update.userId}}",
  "{{update.actorId}}",
  "{{update.type}}",
]

export const ON_ERROR_OPTIONS: Userbot.StepOnError[] = [
  "fail",
  "skip",
  "continue",
]

/** Служебный enum операций записи для SaveSpec.action (не из каталога). */
export const SAVE_ACTIONS: Userbot.SaveSpec["action"][] = [
  "db.save",
  "db.update",
  "db.delete",
]

/** Fallback-примеры cron (если каталог cron-presets недоступен). */
export const CRON_EXAMPLES: { label: string; value: string }[] = [
  { label: "Каждый день в 09:00", value: "0 9 * * *" },
  { label: "Каждый час", value: "0 * * * *" },
  { label: "Каждые 15 минут", value: "*/15 * * *" },
  { label: "По понедельникам в 10:00", value: "0 10 * * 1" },
]

/** Подсказки по операторам ConditionExpr (TZ §2.2, §9.5).
 *  Лимиты (maxRegexPatternLength и т.д.) — из catalog.limits, не хардкодить. */
export const CONDITION_HINTS: Record<string, string> = {
  eq: 'Deep strict equality без коэрции ("5" !== 5). Для типизированных сравнений — whole-string {{stepId.result.n}} (возвращает число), inline {{n}} возвращает строку. type-mismatch НЕ подсвечивается в dry-run.',
  ne: "Deep strict inequality без коэрции. Аналогично eq для типизации.",
  gt: "Только number/number или string/string; иначе false (без warning в UI).",
  gte: "Только number/number или string/string; иначе false.",
  lt: "Только number/number или string/string; иначе false.",
  lte: "Только number/number или string/string; иначе false.",
  in: "right — массив или whole-string {{...}}, резолвящийся в массив на бэке.",
  nin: "right — массив или whole-string {{...}}, резолвящийся в массив на бэке.",
  exists: "Проверяет, что value не undefined/null.",
  empty: "Проверяет, что value пустое (пустая строка, null, пустой массив).",
  regex:
    "pattern ≤ maxRegexPatternLength, без backreferences/lookbehind, flags только imsu.",
  and: "Логическое И. Глубина ≤ maxConditionDepth (из catalog.limits).",
  or: "Логическое ИЛИ. Глубина ≤ maxConditionDepth.",
  not: "Логическое НЕ. Глубина ≤ maxConditionDepth.",
}
